import type { FormDto, FormVersionDto } from "../../services/ApiService";
import type { Form } from "../../state/form";
import { toFormVersion } from "./formVersion";
import { isNil } from "lodash-es";
import FormId from "../../state/FormId";
import { fromLegacyPlatformIcon, toLegacyPlatformIcon } from "../iconUtil";
import FormVersionId from "../../state/FormVersionId";
import { resolveTheme } from "../themeUtil";

export const toFormDto = (form: Form): FormDto => ({
  id: form.id.toString(),
  meta: {
    name: form.meta.name,
    description: form.meta.description,
    icon: toLegacyPlatformIcon(form.meta.icon),
    iconColor: form.meta.theme.name,
    language: form.meta.language,
    tags: form.meta.tags,
  },

  publishedVersion: isNil(form.publishedVersion)
    ? undefined
    : {
        formVersion: form.publishedVersion.formVersionId.toString(),
        publishedDate: form.publishedVersion.publishedDate,
        publishedBy: form.publishedVersion.publishedBy,
      },
  status: form.status,
});

export const toForm = (form: FormDto, publishedFormVersion: FormVersionDto | undefined): Form => {
  const publishedVersion = !isNil(form.publishedVersion?.formVersion)
    ? {
        formVersionId: FormVersionId.from(form.publishedVersion.formVersion),
        formVersion: !isNil(publishedFormVersion) ? toFormVersion(publishedFormVersion, false) : undefined,
        publishedDate: form.publishedVersion.publishedDate,
        publishedBy: form.publishedVersion.publishedBy,
      }
    : undefined;

  const latestVersion = !isNil(form.latestVersion?.id)
    ? {
        id: FormVersionId.from(form.latestVersion.id),
        lastUpdated: new Date(form.latestVersion.lastUpdated),
        lastUpdatedBy: form.latestVersion.lastUpdatedBy,
        status: form.latestVersion.status,
      }
    : undefined;

  return {
    id: FormId.from(form.id),
    meta: {
      name: form.meta.name,
      description: form.meta.description,
      icon: fromLegacyPlatformIcon(form.meta.icon, "document"),
      theme: resolveTheme(form.meta.iconColor),
      language: form.meta.language,
      tags: form.meta.tags,
    },
    publishedVersion,
    latestVersion,
    status: form.status,
  };
};
